/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Snackbar } from '@mui/material';
import MuiAlert, { AlertProps, AlertColor } from '@mui/material/Alert';
import { Notification, NotificationType } from '../../utils/utils';
import { Theme } from '@mui/material/styles';

import createStyles from '@mui/styles/createStyles';
import withStyles from '@mui/styles/withStyles';

interface PreloaderOwnProps {
    onClose(index: number): void;

    notifications: Notification[];
}

const ALERT_SEVERITY_BY_NOTIFICATION_TYPE: Record<NotificationType, AlertColor> = {
    ERROR: 'error',
    NOTIFICATION: 'info',
    WARNING: 'warning',
};

const CustomAlert = withStyles((theme: Theme) =>
    createStyles({
        root: {
            '&.MuiAlert-filledError': {
                backgroundColor: theme.palette.error.main,
                color: theme.palette.error.contrastText,
            },
            '&.MuiAlert-filledWarning': {
                backgroundColor: theme.palette.warning.dark,
                color: theme.palette.error.contrastText,
            },
        },
    }),
)(MuiAlert);

const Alert = (props: AlertProps) => <CustomAlert elevation={6} variant="filled" {...props} />;

const NotificationSnackBar = (props: PreloaderOwnProps) => {
    const { notifications, onClose } = props;

    return (
        <Snackbar
            open={true}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            style={{ marginTop: 50 }}
        >
            <div>
                {notifications.map((notification, index) => {
                    return (
                        <Alert
                            style={{ marginTop: 5 }}
                            key={index}
                            onClose={() => onClose(index)}
                            severity={ALERT_SEVERITY_BY_NOTIFICATION_TYPE[notification.type]}
                        >
                            {notification.message}
                        </Alert>
                    );
                })}
            </div>
        </Snackbar>
    );
};

export default NotificationSnackBar;
